// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"114":"waste-calendar","307":"container-locations","528":"reports","821":"design-system","942":"heat-calculator","998":"registration-desk"}[chunkId] + "." + {"114":"46a0fbbd","307":"956495a6","528":"ae0e5a18","821":"cb2d427e","942":"fc54f2cb","998":"156b2703"}[chunkId] + ".chunk.css";
};